var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-head"},[_c('h3',[_vm._v(_vm._s(_vm.getTitle))])]),_c('div',{staticClass:"panel-body"},[_vm._t("panel-body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }